import { Setup } from "appworks/boot/setup";
import { Components } from "appworks/components/components";
import { ParticleConfig } from "appworks/config/asset-config-schema";
import { gameLoop } from "appworks/core/game-loop";
import { animationManager } from "appworks/graphics/animation/animation-manager";
import { canvasManager } from "appworks/graphics/canvas/canvas-manager";
import { graphicsManager } from "appworks/graphics/graphics-manager";
import { Layers } from "appworks/graphics/layers/layers";
import { gameState } from "appworks/model/game-state";
import { builderManager } from "appworks/server/builders/builder-manager";
import { Services } from "appworks/services/services";
import { StandardI18nAliases } from "appworks/services/translations/standard-i18n-aliases";
import { stateMachine } from "appworks/state-machine/state-machine";
import { uiFlags } from "appworks/ui/flags/ui-flags";
import { Contract } from "appworks/utils/contracts/contract";
import { deviceInfo } from "appworks/utils/device-info";
import { logger } from "appworks/utils/logger";
import { Timer } from "appworks/utils/timer";
import { gameLayers } from "game-layers";
import { DebugMenu } from "slotworks/debug/menu/debug-menu";
import { slotModel } from "slotworks/model/slot-model";

declare var window: any;

//////////////////////////////////////////////////////////////////////////////
/////////////////////
//////////

export abstract class EmptySetup implements Setup {
    public setupServices(): void {
        //
    }

    public setupLayers(): void {
        //
    }

    public setupDebug(): void {
        //
    }

    public setupCanvas(): void {
        //
    }

    public setupComponents(): void {
        //
    }

    public setupComms(): void {
        //
    }

    public setupUI(): void {
        //
    }

    public setupStates(): void {
        //
    }

    public setupTransitions(): void {
        //
    }

    public setupSound(): void {
        //
    }

    public setupAsync(): Contract<void> {
        return Contract.empty();
    }

    public setupI18N(): void {
        StandardI18nAliases();
    }

    public setupGameDefinition(): void {
        //
    }

    public setupParticles(): { [id: string]: ParticleConfig } {
        return {};
    }

    public onReady(): void {
        //
    }
}
